import { render, staticRenderFns } from "./FullscreenModal.vue?vue&type=template&id=6f16f6b8&scoped=true&"
import script from "./FullscreenModal.vue?vue&type=script&lang=js&"
export * from "./FullscreenModal.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenModal.vue?vue&type=style&index=0&id=6f16f6b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f16f6b8",
  null
  
)

export default component.exports